import { cabecalhoExportarRelatorioStyles } from './CabecalhoExportarRelatorio.style'

export function cabecalhoExportarRelatorioIO() {
  return {
    styles: cabecalhoExportarRelatorioStyles
  }
}

export type CabecalhoExportarRelatorioIO = ReturnType<typeof cabecalhoExportarRelatorioIO>
